export const newsWidgeti18n = {
    pt: () => import("./pt.json"),
    en: () => import("./en.json"),
    es: () => import("./es.json")
};